import React, { useEffect, useRef } from "react";

// Interactive cursor lighting: a soft warm glow + dot that follows the pointer
export default function CursorGlow() {
  const glow = useRef(null);
  const dot = useRef(null);

  useEffect(() => {
    const place = (x, y) => {
      const t = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      if (dot.current) dot.current.style.transform = t;
      if (glow.current) glow.current.style.transform = t;
    };
    let x = window.innerWidth / 2, y = window.innerHeight / 2;
    place(x, y);
    const move = (e) => {
      x = e.clientX; y = e.clientY;
      place(x, y);
      const target = e.target;
      const hover = target && target.closest && target.closest("a, button, [role=button], input, textarea, .premium-card");
      if (dot.current) dot.current.classList.toggle("hovering", !!hover);
    };
    const click = () => place(x, y);
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("click", click);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("click", click);
    };
  }, []);

  return (
    <>
      <div ref={glow} className="cursor-glow" aria-hidden="true" />
      <div ref={dot} className="cursor-dot" aria-hidden="true" />
    </>
  );
}
